import { useTranslation } from 'react-i18next';
import CONFIG from '../../config/config';
import { CollectionViewCountry } from '../../api/CollectionsAPI';
import Tooltip from '../Tooltip/Tooltip';

type CatalogViewsCountProps = {
  views: number;
  countries?: CollectionViewCountry[];
};

export const catalogViewCountryLabel = (
  t: (key: string) => string,
  countryCode: string
): string => {
  if (!countryCode || countryCode.toUpperCase() === 'XX') {
    return t('admin.collections.details.views.unknown');
  }
  const country = CONFIG.COUNTRY_CODES.find(
    (entry) => entry.countryCode.toUpperCase() === countryCode.toUpperCase()
  );
  if (!country) {
    return countryCode.toUpperCase();
  }
  const translated = t(country.countryName);
  return translated === country.countryName
    ? country.countryName.replace(/_/g, ' ')
    : translated;
};

const CatalogViewsCount = ({ views, countries = [] }: CatalogViewsCountProps) => {
  const { t } = useTranslation();
  const tooltipContent =
    views === 0
      ? t('admin.collections.details.views.empty')
      : (
          <div className="space-y-1 text-left whitespace-nowrap">
            {countries.map((country) => (
              <div key={country.countryCode}>
                {catalogViewCountryLabel(t, country.countryCode)} {country.percent}%
              </div>
            ))}
          </div>
        );

  return (
    <Tooltip content={tooltipContent} position="bottom">
      <span
        className="inline-flex min-w-[2rem] justify-center text-sm tabular-nums"
        aria-label={
          views === 0
            ? (t('admin.collections.details.views.empty') as string)
            : (t('admin.collections.details.views.tooltip', { count: views }) as string)
        }
      >
        {views}
      </span>
    </Tooltip>
  );
};

export default CatalogViewsCount;
